import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { Text } from "../Text";

export type EmptyTextProps = {
    /** Určuje, zda je komponenta vizuálně aktivní a zda s ní lze pracovat. */
    interactive?: boolean;
    /** Obsah, který má být zobrazen. */
    content?: string;
};
const classNames = bemClassNames("empty-text-component");

/**
 * Komponenta vrací komponentu Text bez hodnoty. Používá se například u záznamu v případech, kdy není dostupná hodnota atributu.
 */
export const EmptyText: FunctionComponent<EmptyTextProps> = ({
    interactive = true,
    content = "",
}) => (
    <span className={classNames()}>
        <Text
            value={content}
            disabled={!interactive}
        />
    </span>
);
